import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import UserDetailsTab from '../UserDetailsTab';
import { useModifyUserMutation, useCreateUserMutation } from '../../../api/users';

const AddEditUser = (props) => {
    const params = useParams();
    const [userDetails, setUserDetails] = useState({});
    const location = useLocation();
    const isEditMode = location.pathname.includes('edit');
    const navigate = useNavigate();

    const { enqueueSnackbar } = useSnackbar();

    const [modifyUser, { isLoading: isModifyLoading }] = useModifyUserMutation();
    const [createUser, { isLoading: isCreateLoading }] = useCreateUserMutation();

    const isLoading = isModifyLoading || isCreateLoading;

    if (isEditMode && userDetails?.secUserInstance?.username === 'superAdmin') navigate('/access-denied');

    useEffect(() => {
        const fetchData = async () => {
            const bodyFormData = new FormData();
            if (params.companyId) {
                bodyFormData.append('company', params.companyId);
            }
            isEditMode && bodyFormData.append('id', params.id);
            const url = isEditMode ? modifyUser : createUser;
            try {
                const response = await url(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setUserDetails(response);
            } catch (error) {
                if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
                else enqueueSnackbar(error?.message || 'Something went wrong!', { variant: 'error' });
            }
        };

        fetchData();
    }, [params.id]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">{isEditMode ? 'Edit User' : 'Add User'}</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() =>
                                        navigate(params.companyId ? `/company/${params.companyId}/users` : '/users')
                                    }
                                >
                                    Back
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item my={2}>
                            <UserDetailsTab isEditMode={isEditMode} userDetails={userDetails} isLoading={isLoading} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AddEditUser;
